exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-user{border-radius:1rem;border-color:#05bdbd;background:linear-gradient(0deg,rgba(5,189,189,.1),rgba(5,189,189,.5))}#myTab .active{background-color:transparent!important}.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){width:55px!important;padding:.3rem;color:#05bdbd;background:#d9f5f5;border-color:#05bdbd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3dc3a4bc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/UserIdentify.vue
// module id = 532
// module chunks = 0